const JOURS = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];

const normalise = (jour) =>
  String(jour || "").trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

const indexJour = (jour) => JOURS.findIndex((j) => normalise(j) === normalise(jour));

const minutes = (heure) => {
  const [h, m] = String(heure || "").replace("h", ":").split(":");
  return (Number(h) || 0) * 60 + (Number(m) || 0);
};

const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août",
  "septembre", "octobre", "novembre", "décembre"];

const isoLocal = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// Nombre de jours entre aujourd'hui et une date « AAAA-MM-JJ » (heure locale).
const joursJusqua = (iso, maintenant) => {
  const [a, m, j] = String(iso).split("-").map(Number);
  const cible = new Date(a, (m || 1) - 1, j || 1);
  const auj = new Date(maintenant.getFullYear(), maintenant.getMonth(), maintenant.getDate());
  return Math.round((cible - auj) / 86400000);
};

/* Le prochain cours de la famille, à partir de maintenant.

   C'est LA question qu'un parent se pose en ouvrant l'app dans un couloir : c'est quand, et
   dans quelle salle. Le serveur donne la vraie date de chaque cours (`prochaine_le`, et
   `suivante_le` pour le soir où celle du jour est passée) : vacances et jours fériés des
   Réglages sautés — l'accueil annonçait le cours du mercredi en pleines vacances d'automne
   (école, 10.10.2026). Sans ces dates (ancien serveur), on balaie les 7 prochains jours. */
export function prochainCours(enfants, maintenant = new Date()) {
  const jourActuel = maintenant.getDay();
  const heureActuelle = maintenant.getHours() * 60 + maintenant.getMinutes();
  const aujourdhui = isoLocal(maintenant);

  const seances = [];
  (enfants || []).forEach((enfant) => {
    (enfant.cours || []).forEach((cours) => {
      const debut = minutes(cours.heure);
      if (cours.prochaine_le !== undefined) {
        const passee = cours.prochaine_le === aujourdhui && debut <= heureActuelle;
        const le = passee ? cours.suivante_le : cours.prochaine_le;
        if (!le) return;                       // plus de séance (dernier cours passé)
        const jours = Math.max(joursJusqua(le, maintenant), 0);
        seances.push({ ...cours, enfant, le, dans: jours * 1440 + debut, jours });
        return;
      }
      const jour = indexJour(cours.jour);
      if (jour < 0) return;
      let attente = (jour - jourActuel + 7) % 7;
      if (attente === 0 && debut <= heureActuelle) attente = 7;
      seances.push({ ...cours, enfant, dans: attente * 1440 + debut, jours: attente });
    });
  });

  seances.sort((a, b) => a.dans - b.dans);
  return seances[0] || null;
}

// Une date « AAAA-MM-JJ » en clair : « lundi 26 octobre ».
export function dateEnClair(iso) {
  const [a, m, j] = String(iso || "").split("-").map(Number);
  if (!a || !m || !j) return "";
  const d = new Date(a, m - 1, j);
  return `${JOURS[d.getDay()].toLowerCase()} ${j} ${MOIS[m - 1]}`;
}

export function quand(seance) {
  if (!seance) return "";
  if (seance.jours === 0) return "aujourd'hui";
  if (seance.jours === 1) return "demain";
  // Au-delà d'une semaine (après les vacances), le jour seul tromperait : la date.
  if (seance.jours >= 7 && seance.le) return dateEnClair(seance.le);
  return seance.jour;
}
